import type { ChipProps } from '@mui/material';

export type AdStatusType =
    | 'ACTIVE'
    | 'MODERATION'
    | 'EXPERT_MODERATION'
    | 'SOLD'
    | 'DELETED'
    | 'REJECTED'
    | 'NEED_CORRECT'
    | 'NEED_EXPERT_PHOTO'
    | 'BLOCKED'
    | 'ATTRIBUTES_UPDATED'
    | string;

export type AdStatusMeta = {
    label: string;
    color: ChipProps['color'];
};

export const AD_STATUS_META: Record<string, AdStatusMeta> = {
    ACTIVE: { label: 'Активно', color: 'success' },
    MODERATION: { label: 'На модерации', color: 'info' },
    EXPERT_MODERATION: { label: 'Экспертная модерация', color: 'warning' },
    SOLD: { label: 'Продано', color: 'default' },
    DELETED: { label: 'Удалено', color: 'default' },
    REJECTED: { label: 'Отклонено', color: 'error' },
    NEED_CORRECT: { label: 'Нужно исправить', color: 'warning' },
    NEED_EXPERT_PHOTO: { label: 'Нужно экспертное фото', color: 'warning' },
    BLOCKED: { label: 'Заблокировано', color: 'error' },
    ATTRIBUTES_UPDATED: { label: 'Изменены атрибуты', color: 'info' },
};

export const KNOWN_AD_STATUSES = Object.keys(AD_STATUS_META) as AdStatusType[];

export const normalizeAdStatus = (status?: string | null) => {
    if (typeof status !== 'string') {
        return '';
    }
    return status.trim().toUpperCase();
};

export const getAdStatusMeta = (status?: AdStatusType | null): AdStatusMeta => {
    const normalizedStatus = normalizeAdStatus(status);
    return AD_STATUS_META[normalizedStatus] || {
        label: normalizedStatus || 'Не указано',
        color: 'default'
    };
};
